import { ApiClient, MemoryTokenStore } from '@rydres/api-client';
import type { GeoPlace, RouteSummary } from '@rydres/shared';
import type { GeoApi } from '@rydres/ui';

export const API_ORIGIN =
  (import.meta.env.VITE_API_ORIGIN as string | undefined) ?? 'https://api.rydres.com';
export const STRIPE_PUBLISHABLE_KEY = (import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined) ?? '';

/** Public calls; a passenger's own account uses `passengerApi` (lib/passenger.ts). */
export const api = new ApiClient({ baseUrl: `${API_ORIGIN}/v1`, store: new MemoryTokenStore() });

/** Address suggestions, the address at the browser's location, and drives; no sign-in needed. */
export const geoApi: GeoApi = {
  search: (q, near) =>
    api.call<{ places: GeoPlace[] }>('GET', '/geo/search', { auth: false, query: { q, ...(near ? { lat: String(near.lat), lng: String(near.lng) } : {}) } }).then((r) => r.places),
  reverse: (p) => api.call<{ place: GeoPlace | null }>('GET', '/geo/reverse', { auth: false, query: { lat: String(p.lat), lng: String(p.lng) } }).then((r) => r.place),
  route: (from, to) =>
    api.call<{ route: RouteSummary }>('GET', '/geo/route', { auth: false, query: { from: `${from.lat},${from.lng}`, to: `${to.lat},${to.lng}` } }).then((r) => r.route),
};
